import React from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../shared/contexts/LanguageContext';
import { ContentUseCase } from '../../corelogic/usecases/ContentUseCase';

const contentUseCase = new ContentUseCase();

export const FloatingDonateButton: React.FC = () => {
  const theme = useTheme();
  const { language } = useLanguage();
  const { fundraiserInfo } = contentUseCase.getAllContent(language);

  return (
    <>
      {/* Desktop version - vertical at edge */}
      <Box
        sx={{
          position: 'fixed',
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 1000,
          display: { xs: 'none', md: 'block' },
        }}
      >
        <Button
          variant="contained"
          size="small"
          component={Link}
          to="/mitmachen"
          sx={{
            px: theme.spacing(0.25),
            py: theme.spacing(3),
            fontSize: '0.7rem',
            fontWeight: 600,
            backgroundColor: 'primary.main',
            color: 'white',
            borderRadius: '6px 0 0 6px',
            boxShadow: theme.shadows[4],
            writingMode: 'vertical-rl',
            textOrientation: 'mixed',
            minHeight: '120px',
            minWidth: '24px',
            '&:hover': {
              backgroundColor: 'primary.dark',
              boxShadow: theme.shadows[8],
              transform: 'scale(1.02)',
            },
            transition: 'all 0.2s ease-in-out',
          }}
        >
          {fundraiserInfo.joinUs.floatingLabel}
        </Button>
      </Box>

      {/* Mobile version - horizontal at bottom */}
      <Box
        sx={{
          position: 'fixed',
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 1000,
          display: { xs: 'block', md: 'none' },
        }}
      >
        <Button
          variant="contained"
          size="small"
          component={Link}
          to="/mitmachen"
          sx={{
            px: theme.spacing(0.5),
            py: theme.spacing(2),
            fontSize: '0.7rem',
            fontWeight: 600,
            backgroundColor: 'primary.main',
            color: 'white',
            borderRadius: '6px 0 0 6px',
            boxShadow: theme.shadows[4],
            writingMode: 'vertical-rl',
            textOrientation: 'mixed',
            minHeight: '100px',
            minWidth: '28px',
            '&:hover': {
              backgroundColor: 'primary.dark',
              boxShadow: theme.shadows[8],
              transform: 'scale(1.02)',
            },
            transition: 'all 0.2s ease-in-out',
          }}
        >
          {fundraiserInfo.joinUs.floatingLabel}
        </Button>
      </Box>
    </>
  );
};
